import {Component} from '@angular/core';
import {LoadingVacatureDetailComponent} from '../loading-vacature-detail/loading-vacature-detail.component';

@Component({
  selector: 'mvw-loading-vacature-info',
  templateUrl: './loading-vacature-info.component.html',
  imports: [LoadingVacatureDetailComponent]
})
export class LoadingVacatureInfoComponent {

}
